import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
export var union = function union() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    var supportedTypes = new Set(['string', 'object', 'boolean', 'number', 'bigint']);
    return fns.map(function (f) {
      return f(x);
    }).reduce(function (acc, value) {
      if (value == undefined) {
        return acc;
      }

      if (!supportedTypes.has(typeof acc) || !supportedTypes.has(typeof value)) {
        throw new Error("Type ".concat(typeof value, " as returning type of a union statement, not supported"));
      }

      if (typeof acc !== typeof value || Array.isArray(acc) !== Array.isArray(value)) {
        throw new Error('Mismatch between returning types of union statement');
      }

      if (Array.isArray(value) || typeof value === 'string') {
        return acc.concat(value);
      }

      if (typeof value === 'object') {
        return Object.assign({}, acc, value);
      }

      if (typeof value === 'boolean') {
        return acc || value;
      }

      if (typeof value === 'number' || typeof value === 'bigint') {
        return acc + value;
      }
    });
  };
};